import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ValuesView from "../views/ValuesView.vue";
import ContactView from "../views/ContactView.vue";
import CareersView from "../views/CareersView.vue";
import ServicesView from "../views/ServicesView.vue";
import Feedback from "../views/FeedbackView.vue";

const router = createRouter({
  //history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory("/"),
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomeView,
    },
    {
      path: "/about",
      name: "About",
      component: AboutView,
    },
    {
      path: "/values",
      name: "Values",
      component: ValuesView,
    },
    {
      path: "/contact",
      name: "Contact",
      component: ContactView,
    },
    {
      path: "/careers",
      name: "Careers",
      component: CareersView,
    },
    {
      path: "/services",
      name: "Services",
      component: ServicesView,
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
    },
  ],
});

export default router;
